import { EntityRepository, Repository } from "typeorm";
import { EtdWise } from "../entity/etd-wise-grid.entity";

@EntityRepository(EtdWise)
export class EtdWiseDataRepository extends Repository<EtdWise> {

}